import { computed, ref, watch, Ref } from 'vue'

/**
 * Once a navless route (the CCP softphone popup) has successfully cleared
 * the loading gate, later transient `loadingErrorMessage` blips — e.g. the
 * popup's Auth0 session expiring mid-shift — must not blank the page behind
 * a full-screen loading overlay: that would cover a live call with no way
 * for the agent to notice why, since the navless route has no chrome to
 * explain it. Initial load still blocks normally, same as any other route.
 * See CT-821.
 * @param loadingErrorMessage
 * @param navless
 */
export function useNavlessLoadingGate(
  loadingErrorMessage: Ref<string>,
  navless: Ref<boolean>
): Ref<boolean> {
  const hasLoadedNavlessRouteOnce = ref(false)

  watch(
    [loadingErrorMessage, navless],
    ([currentLoadingErrorMessage, isNavless]) => {
      if (!currentLoadingErrorMessage && isNavless) {
        hasLoadedNavlessRouteOnce.value = true
      }
    },
    { immediate: true }
  )

  return computed(
    () => !!loadingErrorMessage.value && !hasLoadedNavlessRouteOnce.value
  )
}
